export default class CloseAnswerPanel {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, compositionId }) {
    const answerPanel = this.context.stores.answerPanel.get();
    answerPanel.clearAnswer();
    answerPanel.clearHistory();
    answerPanel.clearSearchResult();
    answerPanel.close();
    this.context.stores.answerPanel.set(answerPanel);

    this.context.stores.snippetSearchResult.remove();
    this.context.analytics.track('Answer Panel Closed', { customerId, conversationId, compositionId });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/answers/close_answer_panel.js